import BookShow from "components/shared/book/show";
import { serializeReq } from "helpers/form";
import { viewContainer } from "helpers/redux";
import moment from "moment";
import React from "react";
import { config, getConfig, initialState } from "../form/config";
import Markup from "./markup";

const uppercaseDocumentFields = new Set(["passportSeries", "passportNumber", "licenseSeries", "licenseNumber"]);

class ShowHiredDriver extends BookShow {
    getValidationConfig = (state) => getConfig(state);

    setValue = ({ value, name }) => {
        const { data, initial } = this.state;
        const formattedValue =
            uppercaseDocumentFields.has(name) && typeof value === "string" ? value.toUpperCase() : value;
        const nextData = { ...data, [name]: formattedValue };
        const allKeys = new Set([...Object.keys(initial || {}), ...Object.keys(nextData || {})]);
        const shouldUpdate = Array.from(allKeys).some((key) => (initial?.[key] ?? null) !== (nextData?.[key] ?? null));
        const isValid = this.isValidForm(nextData);
        this.setState({ data: nextData, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    get dropdActions() {
        const { canEditBooks } = this.props;
        return canEditBooks ? [{ text: "Удалить", action: this.actionClose }] : [];
    }

    apply = () => {
        const { source, match, mergeParams, config } = this.props;
        const { isLoading, shouldUpdate, ...state } = this.state;
        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(state.data)) {
                const formatted = serializeReq({ id: match.params, ...state.data }, config);
                if (formatted.passportDateOfIssue) {
                    formatted.passportDateOfIssue = moment(formatted.passportDateOfIssue).format("YYYY-MM-DD");
                }
                if (formatted.licenseDateOfIssue) {
                    formatted.licenseDateOfIssue = moment(formatted.licenseDateOfIssue).format("YYYY-MM-DD");
                }
                if (formatted.licenseExpirationDate) {
                    formatted.licenseExpirationDate = moment(formatted.licenseExpirationDate).format("YYYY-MM-DD");
                }
                this.setState({ isLoading: true, isValid: true });
                return source
                    .apply(formatted)
                    .then((res) =>
                        res ? this.update(mergeParams) : this.setState({ isLoading: false, isValid: false }),
                    );
            }
            this.setState({ isValid: false });
        }
    };

    renderBody = () => {
        const currentConfig = getConfig(this.state.data);
        return (
            <Markup
                {...currentConfig}
                renderField={this.renderField}
                renderDateField={this.renderDateField}
                renderSelect={this.renderSelect}
                Button={this.renderButton}
            />
        );
    };
}

const ConfiguredShow = (props) => (
    <ShowHiredDriver
        {...props}
        canEditBooks={props.canEditBooks && !props.roles.isTruckingOrganizationExtendedViewer}
        config={config}
        initialState={initialState}
    />
);

export default viewContainer(ConfiguredShow, "hired-drivers");
